import routerOptions0 from "E:/workspace/roncoo/roncoo-web/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}